import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DaysOff } from "../../drivers.types";
import { requestGetDaysOff } from "./getDaysOff.request";

const useGetDaysOff = (
  companyId?: string,
  options?: QueryOptions<DaysOff, ApiServiceError<ApiError>>
) => {
  const { data: daysOff, ...rest } = useQuery({
    queryKey: ["admin", "days-off", companyId ?? "global"],
    queryFn: () => requestGetDaysOff(companyId),
    cacheTime: 0,
    ...options
  });

  return { daysOff, ...rest };
};

export default useGetDaysOff;
